import axios from "axios";
import { API } from "./apis";
import authHeader from "./authHeader";

export const getAllACVideos = (isAccessToken: boolean) => {
  if (isAccessToken) {
    return axios.get(API.ACVideos, { headers: authHeader() });
  } else {
    return axios.get(API.publicVideos);
  }
};

export const getPublicVideos = () => {
  return axios.get(API.publicVideos);
};
